import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IProductModel } from '@apps-common/types/management/product'

export const updateProduct = async (model: IProductModel, image: any): Promise<IProductModel> =>
  new Promise((resolve, reject) => {
    axios
      .post(`/management/product/updateproduct`, model)
      .then((res) => {
        if (image) {
          const fileData = new FormData()

          fileData.append('file', image?.blob || image)
          axios
            .post(`/management/product/uploadimg?productId=${model.productId}`, fileData)
            .then((imageRes) => resolve(imageRes?.data?.data))
            .catch((err) => reject(err))
        } else {
          resolve(res?.data?.data)
        }
      })
      .catch((err) => reject(err))
  })

type Props = {
  model: IProductModel
  image: File | null | undefined
}

export const useManagementUpdateProduct = (notify?: boolean, onSuccess?: (data: IProductModel) => void) =>
  useMutation({
    mutationKey: ['updateProduct'],
    mutationFn: ({ model, image }: Props) => updateProduct(model, image),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated product.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update product, please try again.')
      }
    },
    throwOnError: false
  })
